import { Injectable } from '@angular/core';
import { InfrastructureService } from './infrastructure.service';
import { Budget } from '../models/models';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BudgetService extends InfrastructureService<Budget> {
  public readonly endpoint: string = '/Budgets';

  constructor(protected http: HttpClient) {
    super(http);
  }

  public updateBulk(entity: Budget[]): Observable<unknown> {
    const operation: string = 'update';

    const url: string = `${this.endpoint}/bulk`;
    return this.http.put(url, entity).pipe(catchError(this.handleError(operation)));
  }
}
